import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, {Component} from 'react';
import {connect} from 'react-redux';
import DimeCardList from '../components/DimeCardList';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import {App, uFirstName, uLastName, uRating, uId, uImage, uIsSignedIn} from '../containers/App';
import { FaSignOutAlt, FaUser, FaUsers, FaHome, FaPlus } from "react-icons/fa";
import {setSearchField, requestRobots } from '../actions';
import { getSecureItem } from '../utils/encryption';
import env from "react-dotenv";

let URL = `${env.API_URL}/allDimes`;
let BLOCKED_URL = `${env.API_URL}/blockedDimes`;

const mapStateToProps = state => {
  return{
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class Dimes extends Component{
  constructor() {
    super();
    
    // Start with empty state - don't load from localStorage to prevent glitching
    this.state = {
      route: 'signin',
      isSignedIn: false,
      isLoading: true,
      error: null,
      userId: '',
      userDataReady: false, // Track when user data is loaded to prevent flash
      dime: {
        dime_id: '',
        user_id: '',
        rating_count: '',
        category: '',
        image_key: '',
        rating: ''
      },
      robots: [],
      blockedUsers: [],
      updatedFiltered: [],
      searchfield: ''
    }
    this.setStateApp = this.setStateApp.bind(this);
    this.userDataLoaded = false;
    this.initialLoadComplete = false;
    this.isFetching = false; // Guard against multiple simultaneous fetches
    
    // Load userId synchronously in constructor
    this.loadUserIdSync();
  }

  loadUserIdSync() {
    try {
      // First check window.uId
      if (window.uId) {
        this.state.userId = window.uId;
        return;
      }
      
      // Try to load from encrypted storage
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        this.state.userId = savedState.user.id;
      }
    } catch (error) {
      console.error('Error in loadUserIdSync:', error);
    }
  }

  // Keep this for reference but don't use in constructor
  loadStateFromStorage() {
    // Don't load from storage if we just navigated here - prevents glitching
    if (sessionStorage.getItem('dimes-just-loaded')) {
      sessionStorage.removeItem('dimes-just-loaded');
      return { robots: [], updatedFiltered: [] };
    }
    
    try {
      const savedState = localStorage.getItem('p10-dimes-state');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        
        // Check if cached data is recent (less than 5 minutes old)
        const timestamp = parsed.timestamp || 0;
        const fiveMinutes = 5 * 60 * 1000;
        const isRecent = (Date.now() - timestamp) < fiveMinutes;
        
        if (!isRecent) {
          return { robots: [], updatedFiltered: [] };
        }
        
        if (!Array.isArray(parsed.robots)) {
          parsed.robots = [];
        }
        if (!Array.isArray(parsed.updatedFiltered)) {
          parsed.updatedFiltered = [];
        }
        return parsed;
      }
    } catch (error) {
      console.error('Error loading state from storage:', error);
    }
    return { robots: [], updatedFiltered: [] };
  }

  saveStateToStorage() {
    try {
      const stateToSave = {
        isSignedIn: this.state.isSignedIn,
        robots: this.state.robots,
        blockedUsers: this.state.blockedUsers,
        updatedFiltered: this.state.updatedFiltered,
        timestamp: Date.now()
      };
      localStorage.setItem('p10-dimes-state', JSON.stringify(stateToSave));
    } catch (error) {
      console.error('Error saving state to storage:', error);
    }
  }

  // Ensure userId is ALWAYS set - critical for maintaining session
  ensureUserIdSet() {
    // CRITICAL: Always try to restore userId from multiple sources
    const storedUserId = this.state.userId;
    
    // First check if window.uId exists
    if (window.uId) {
      // Make sure state matches
      if (this.state.userId !== window.uId) {
        this.setState({ userId: window.uId, isSignedIn: true, userDataReady: true });
      }
      return true; // We're good
    }
    
    // Window.uId is missing, try to restore from state
    if (storedUserId) {
      window.uId = storedUserId;
      window.uIsSignedIn = true;
      this.setState({ isSignedIn: true, userDataReady: true });
      return true;
    }
    
    // Both are missing, try to load from encrypted storage
    try {
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        window.uRating = savedState.user.rating;
        window.uRatingCount = savedState.user.rating_count;
        window.uImageKey = savedState.user.image_key;
        window.uAdministrator = savedState.user.administrator;
        window.uGender = savedState.user.gender;
        window.uEmail = savedState.user.email;
        window.uJoined = savedState.user.joined;
        window.uProfileImage = savedState.user.profile_image;
        window.uIsSignedIn = true;
        
        this.setState({ 
          userId: savedState.user.id,
          isSignedIn: true,
          userDataReady: true
        });
        return true;
      } else {
        this.setState({ userDataReady: true });
        return false;
      }
    } catch (error) {
      console.error('Dimes: Error restoring userId:', error);
      this.setState({ userDataReady: true });
      return false;
    }
  }

  // Load user data from encrypted storage OR window globals
  loadUserData() {
    return this.ensureUserIdSet();
  }

  async setStateApp() {
    try {
      
      const response = await fetch(URL, {
        method: 'GET',
        contentType: 'application/json',
        credentials: 'include',
        headers: {Authorization: env.API_KEY}
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('setStateApp: API error response:', errorText);
        throw new Error(`Failed to fetch dimes: ${response.status} ${response.statusText}`);
      }
      
      const users = await response.json();
      const usersArray = Array.isArray(users) ? users : [];
      
      this.setState({
        robots: usersArray,
        error: null
      });
      
      return usersArray;
    } catch (error) {
      console.error('Error fetching dimes:', error);
      this.setState({ 
        error: 'Failed to load dimes. Please try again.',
        isLoading: false 
      });
      return [];
    }
  }

  async getBlockedUsers() {
    // Guard against multiple simultaneous fetches
    if (this.isFetching) {
      return;
    }
    
    
    // Ensure user data is loaded before proceeding
    const userLoaded = this.ensureUserIdSet();
    
    if (!userLoaded) {
      console.error('getBlockedUsers: User data not available');
      this.setState({ 
        isLoading: false,
        userDataReady: true,
        error: 'Please sign in to view dimes'
      });
      return;
    }

    this.isFetching = true; // Set guard
    this.setState({ isLoading: true, userDataReady: true });
    
    try {
      const robotsResult = await this.setStateApp();
      
      // Check if setStateApp failed
      if (!robotsResult || robotsResult.length === 0) {
        this.setState({
          robots: [],
          updatedFiltered: [],
          blockedUsers: [],
          isLoading: false,
          error: null // Clear error if it's just empty results
        });
        this.isFetching = false; // Release guard
        return;
      }
      
      const userId = window.uId || this.state.userId;
      
      if (!userId) {
        console.error('getBlockedUsers: No user ID available after load attempt');
        this.setState({ 
          isLoading: false,
          error: 'Please sign in to view dimes'
        });
        this.isFetching = false; // Release guard
        return;
      }
      
      const response = await fetch(BLOCKED_URL, {
        method: 'post',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'}, 
        body: JSON.stringify({
        })
      });
      
      if (!response.ok) {
        throw new Error(`Blocked dimes API failed: ${response.status}`);
      }
      
      const users = await response.json();
      
      if (users !== "Please sign in" && Array.isArray(users)) {  
        const blockedDimeIds = users.map(user => user.dime_id);
        
        const filteredDimes = this.state.robots.filter(
          robot => !blockedDimeIds.includes(robot.dime_id)
        );
        
        this.setState({
          blockedUsers: blockedDimeIds,
          updatedFiltered: filteredDimes,
          isLoading: false,
          error: null
        }, () => {
          this.saveStateToStorage();
          // Re-ensure userId after save
          this.ensureUserIdSet();
          this.isFetching = false; // Release guard
        });
      } else {
        console.error('getBlockedUsers: Invalid response from blocked users API:', users);
        this.setState({ 
          isLoading: false,
          error: 'Please sign in to continue' 
        });
        this.isFetching = false; // Release guard
      }
    } catch (error) {
      console.error('getBlockedUsers: Error:', error);
      this.setState({ 
        robots: [],
        updatedFiltered: [],
        error: 'Failed to load dimes. Please try again.',
        isLoading: false 
      });
      this.isFetching = false; // Release guard
    }
  }

  handleRefresh = () => {
    // Clear localStorage and mark that we're refreshing
    localStorage.removeItem('p10-dimes-state');
    sessionStorage.setItem('dimes-just-loaded', 'true');
    
    this.setState({ 
      robots: [],
      updatedFiltered: [],
      isLoading: true 
    }, () => {
      this.isFetching = false; // Reset guard before fetching
      this.getBlockedUsers();
    });
  }

  // Method that can be called by child components (like rating modal) to refresh data
  refreshDimesAfterRating = () => {
    console.log('refreshDimesAfterRating: Refreshing dimes after rating submission');
    this.isFetching = false; // Reset guard
    this.getBlockedUsers();
  }

componentDidMount() {
  sessionStorage.setItem('dimes-just-loaded', 'true');
  
  this.handleVisibilityChange = () => {
    if (!document.hidden) {
      this.ensureUserIdSet();
      if (this.state.updatedFiltered.length === 0 && !this.state.isLoading) {
        this.getBlockedUsers();
      }
    }
  };
  document.addEventListener('visibilitychange', this.handleVisibilityChange);
  
  // ✅ Just load data - don't check for cookie (it's HttpOnly)
  const userLoaded = this.ensureUserIdSet();
  
  if (userLoaded) {
    this.initialLoadComplete = true;
    this.getBlockedUsers();  // Just call it directly
  } else {
    console.log('Dimes: No user session found');
    this.setState({
      isLoading: false,
      userDataReady: true,
      error: 'Please sign in to view dimes'
    });
  }
}

  componentWillUnmount() {
    // Clean up listener
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // ALWAYS ensure window.uId is set on every update - CRITICAL!
    this.ensureUserIdSet();
    
    // Save state when filtered dimes change (but not on every update to avoid loops)
    if (prevState.updatedFiltered.length !== this.state.updatedFiltered.length) {
      this.saveStateToStorage();
    }

    // REMOVED: updateFlag logic that was causing redundant fetches
    // The component now only fetches once in componentDidMount or when explicitly refreshed
  }

  loadUser = (data) => {
    this.setState({
      dime: {
        dime_id: '',
        user_id: '',
        rating_count: '',
        category: '',
        image_key: '',
        rating: ''
      }
    })
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState({isSignedIn: false});
      localStorage.removeItem('p10-dimes-state');
      this.userDataLoaded = false;
    } else if (route === 'home') {
      this.setState({isSignedIn: true});
      // Fetch fresh data when navigating to home
      this.getBlockedUsers();
    }
    this.setState({route: route});
  }
  
  render(){
    // Always ensure userId is set before render
    this.ensureUserIdSet();
    
    const userId = window.uId || this.state.userId;
    const userName = window.uFirstName || uFirstName;
    
    const { isSignedIn, route, isLoading, error } = this.state;
    const { searchField, onSearchChange, isPending } = this.props;
    
    const filteredArray = Array.isArray(this.state.updatedFiltered) ? this.state.updatedFiltered : [];
    
    const filteredRobots = filteredArray.filter(robot => {
      return robot && robot.category && 
             robot.category.toLowerCase().includes(searchField.toLowerCase());
    });

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/dimes" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px',borderRadius: '8px' }}/>
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>All Dimes</span>
            </Navbar.Brand>
            
            <div style={{ 
              flex: '1', 
              maxWidth: '900px', 
              margin: '0 20px',
              display: window.innerWidth < 992 ? 'none' : 'block'
            }}>
              <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search dimes by category..."/>
            </div>
            
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <div style={{ 
                display: window.innerWidth >= 992 ? 'none' : 'block',
                padding: '10px 0'
              }}>
                <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search dimes by category..."/>
              </div>
              
              <Nav className="ms-auto">
                <Link to={'/home'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaHome style={{ marginRight: '6px' }}/> Home
                </Link>
                <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUser style={{ marginRight: '6px' }}/> Profile
                </Link>
                <Link to={'/userdimes'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUsers style={{ marginRight: '6px' }}/> User Dimes
                </Link>
                <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaPlus style={{ marginRight: '6px' }}/> Add Dimes
                </Link>
                <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }}>
          <div className="tc">
            {/* Welcome Header */}
            <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
              Discover Amazing Dimes
            </h1>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.5rem', color: '#6b7280', margin: 0 }}>
                Browse the community's favorite collections
              </h2>
              <button 
                onClick={this.handleRefresh}
                style={{
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                🔄 Refresh
              </button>
            </div>
            
            {/* Error Alert */}
            {error && (
              <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                {error}
              </Alert>
            )}
            
            {/* Show loading until user data is ready */}
            {!this.state.userDataReady || isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                {/* No Results Message */}
                {filteredRobots.length === 0 && !isLoading && (
                  <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No dimes found</h2>
                    <p style={{ color: '#9ca3af', marginBottom: '20px' }}>
                      {searchField ? 'Try adjusting your search' : 'No dimes available at the moment'}
                    </p>
                  </div>
                )}
                
                {/* Pinterest-Style Masonry Grid */}
                {filteredRobots.length > 0 && (
                  <DimeCardList 
                    setTest={this.setStateApp} 
                    robots={filteredRobots}
                    onRatingSubmitted={this.refreshDimesAfterRating}
                  />
                )}
              </>
            )}
          </div>
        </Container>

        {/* Modern Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2025 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
              <Link to="/about" style={{ color: '#3b82f6', textDecoration: 'none' }}>About</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dimes);